import React from 'react'
import { Mdx, MdxFrontmatter, MdxFrontmatterLinks } from 'generated/types/gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { Link } from 'gatsby'
import './card.scss'
import Maybe from 'graphql/tsutils/Maybe'

interface CardProps {
  readonly data: { __typename?: 'Mdx' } & Pick<Mdx, 'id' | 'body'> & {
      frontmatter: Maybe<
        { __typename?: 'MdxFrontmatter' } & Pick<MdxFrontmatter, 'title' | 'icon'> & {
            links: Maybe<
              Array<
                Maybe<
                  { __typename?: 'MdxFrontmatterLinks' } & Pick<
                    MdxFrontmatterLinks,
                    'title' | 'path' | 'header' | 'top'
                  >
                >
              >
            >
          }
      >
    }
}

export const Card = ({ data }: CardProps) => {
  const { frontmatter, body } = data
  return (
    <div className="card">
      <strong className="card-title">
        {frontmatter?.title}
        {frontmatter?.icon && (
          <div className="card-icon">
            <i className={'la-icon-' + frontmatter.icon}></i>
          </div>
        )}
      </strong>
      <div className="card-body">
        <MDXRenderer links={frontmatter?.links}>{body}</MDXRenderer>
        {frontmatter?.links && (
          <ul>
            {frontmatter.links?.map(
              (link) =>
                link?.top && (
                  <li key={link.title}>
                    <Link
                      className={`la-link la-icon la-icon_document`}
                      to={`${frontmatter.title}/${link.path}`}
                    >
                      {link.title}
                    </Link>
                  </li>
                )
            )}
            <li>
              <Link className={`la-link`} to={`/${frontmatter.title}`}>
                See more...
              </Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  )
}
